<script setup lang="ts" generic="T extends boolean">
import HelpTooltip from "@/components/HelpTooltip.vue";
import Typography from "@/components/ui/typography/Typography.vue";
import DrillFormField from "@/components/drills/form/DrillFormField.vue";

import DrillFieldRadioGroup from "./fields/DrillFieldRadioGroup.vue";
import DrillFieldCheckboxGroup from "./fields/DrillFieldCheckboxGroup.vue";

const props = defineProps<{
  field: string;
  title: string;
  tooltip?: string;
  multiple: T;
  options: { value: string; title: string; required?: boolean }[];
  max?: number;
  hidden?: boolean;
}>();

const model = defineModel<T extends true ? string[] : string>();
</script>

<template>
  <DrillFormField
    :title="$t(`DrillConfig.label.${props.title}`)"
    :tooltip="props.tooltip"
    v-if="!props.hidden"
  >
    <DrillFieldRadioGroup
      v-if="!props.multiple"
      :field="props.field"
      :options="props.options"
      v-model="model"
    />
    <DrillFieldCheckboxGroup
      v-if="props.multiple"
      :field="props.field"
      :options="props.options"
      :max="props.max"
      v-model="model"
    />
  </DrillFormField>
</template>
